import axios from "axios";

import Config from "src/config";

const v2_actionCriarAgendamento = (clienteId,data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/agendamentos/criar`,
        data,
        maxContentLength: Infinity,
        maxBodyLength: Infinity,        
    });
};

export default v2_actionCriarAgendamento;
